/**
 * 防抖
 * @param {callback} callback - 回调函数
 * @param {number} [wait] - 时间(默认500毫秒) 
 */
let timeout = null
const debounce = (callback, wait = 500) => {
  if (timeout !== null) clearTimeout(timeout)
  timeout = setTimeout(() => {
    timeout = null
    callback && callback()
  }, wait);
}

export default debounce;